export default "__VITE_ASSET__aaad8bf5__"